export const SHORT_DESCRIPTION_TEXT_MAX_CHAR = 100;
export const DESCRIPTION_TEXT_MAX_CHAR = 1000;
export const DESCRIPTION_TEXT_ROWS = 3;
export const SHORT_DESCRIPTION_TEXT_ROWS = 1;
export const ADDITIONAL_INFO_TEXT_MAX_CHAR = 800;
export const ADDITIONAL_INFO_TEXT_ROWS = 3;
